import { NewConnectionSite } from "../../types/NewConnectionSite";

export const isComplexConnection = (site: NewConnectionSite): boolean => {
  if (site.lotCount === "More than 10") {
    return true;
  }

  return site.lots.some((lot) => lot.fuseAmp.toLowerCase() === "more than 100");
};
